import { useSessionContext } from 'Context/SessionContext'
import { Navigate, Outlet } from 'react-router-dom'

const SecurityLayout = () => {
    const { session } = useSessionContext();
    return !session.isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default SecurityLayout